import { setBackendDomain } from "./management";
import jwtAuthAxios from "../auth/jwtAuth";

/**
 * Get integration server logs
 * GET /api/v1/logs/integration-server-logs
 *
 * @param {Object} params - Query parameters
 * @param {number} [params.limit] - Page size (default 50)
 * @param {number} [params.offset] - Offset for pagination
 * @param {string} [params.entityType] - Filter by entity type
 * @param {string} [params.action] - Filter by action
 * @param {string} [params.status] - One of INFO | WARNING | ERROR | DEBUG
 * @param {string} [params.createdFrom] - ISO date or date-time
 * @param {string} [params.createdTo] - ISO date or date-time
 * @returns {Promise<{ ok: boolean, data: { items: Array, total: number, limit: number, offset: number } }>}
 */
export const getIntegrationServerLogs = async ({
  limit = 50,
  offset = 0,
  entityType,
  action,
  status,
  createdFrom,
  createdTo,
} = {}) => {
  setBackendDomain(jwtAuthAxios);

  const params = {};
  if (limit != null) params.limit = limit;
  if (offset != null) params.offset = offset;
  if (entityType !== undefined && entityType !== null && entityType !== "")
    params.entityType = entityType;
  if (action !== undefined && action !== null && action !== "")
    params.action = action;
  if (status !== undefined && status !== null && status !== "")
    params.status = status;
  if (createdFrom !== undefined && createdFrom !== null && createdFrom !== "")
    params.createdFrom = createdFrom;
  if (createdTo !== undefined && createdTo !== null && createdTo !== "")
    params.createdTo = createdTo;

  const { data } = await jwtAuthAxios.get(
    "/api/v1/logs/integration-server-logs",
    { params },
  );
  return data;
};
